"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetStudySpecBySiteIdResponse = exports.GetStudySitesSummaryResponse = exports.UpdateStudySiteResponse = exports.CreateStudySiteResponse = exports.GetStudySiteResponse = void 0;
class GetStudySiteResponse {
}
exports.GetStudySiteResponse = GetStudySiteResponse;
class CreateStudySiteResponse {
}
exports.CreateStudySiteResponse = CreateStudySiteResponse;
class UpdateStudySiteResponse {
}
exports.UpdateStudySiteResponse = UpdateStudySiteResponse;
class GetStudySitesSummaryResponse {
}
exports.GetStudySitesSummaryResponse = GetStudySitesSummaryResponse;
class GetStudySpecBySiteIdResponse {
}
exports.GetStudySpecBySiteIdResponse = GetStudySpecBySiteIdResponse;
//# sourceMappingURL=studySite.js.map